import { render, staticRenderFns } from "./AssignedUsersTableClient.vue?vue&type=template&id=44bf41cc&"
import script from "./AssignedUsersTableClient.vue?vue&type=script&lang=js&"
export * from "./AssignedUsersTableClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports